import React, { useEffect, useState } from "react";
import { Modal, CloseButton } from "react-bootstrap";
import axios from "axios";
import { getAuth } from "../../../app/modules/auth";
import { BadgeStatus } from "../badges/statusBadge";

// 🟢 IMPORT DO NOVO COMPONENTE DE FATURAS
import UserInvoicesModal from "./UserInvoicesModal";

interface Props {
  _user_id: number;
  user: any;
}

const UserFinancialTab: React.FC<Props> = ({ _user_id, user }) => {
  const [contracts, setContracts] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [modalPdf, setModalPdf] = useState<boolean>(false);
  const [pdfLink, setPdfLink] = useState<string | null>(null);

  // 🟢 ESTADOS PARA A MODAL DE FATURAS
  const [showInvoicesModal, setShowInvoicesModal] = useState<boolean>(false);
  const [selectedContractForInvoices, setSelectedContractForInvoices] = useState<any>(null);

  const apiToken = getAuth();
  const token = apiToken?.api_token;
  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchContracts = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          `${apiUrl}/users/${_user_id}/contracts?amount=100&page=1&status=all`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        
        let extractedContracts: any[] = [];
        
        if (Array.isArray(res.data)) {
          extractedContracts = res.data;
        } else if (res.data && Array.isArray(res.data.data)) {
          extractedContracts = res.data.data;
        } else if (res.data && Array.isArray(res.data.contracts)) {
          extractedContracts = res.data.contracts;
        }

        setContracts(extractedContracts);
      } catch (error) {
        setContracts([]); 
      } finally {
        setLoading(false);
      }
    };

    if (_user_id) fetchContracts();
  }, [_user_id, apiUrl, token]);

  const handleViewContract = async (item: any) => {
    try {
      setLoading(true);

      if (item?.integration_key) {
        const res = await axios.get(
          // `${apiUrl}/integrations/clicksign/documents/${item.integration_key}/url`,
          `${apiUrl}/users/${_user_id}/contracts/${item._id}/pdf`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        const freshLink = res.data?.url || res.data?.pdf_link;
        if (freshLink) {
          setPdfLink(freshLink);
          setModalPdf(true);
          setLoading(false);
          return;
        }
      }

      const staticLink = item?.pdf_link || item?.signed_upload_contract_path || item?.upload_contract_path;
      if (staticLink) {
        setPdfLink(staticLink);
        setModalPdf(true);
      } else {
        alert("Este contrato não possui um documento vinculado.");
      }
    } catch (error) {
      alert("Falha ao comunicar com a provedora do contrato (Clicksign).");
    } finally {
      setLoading(false);
    }
  };

  const closePdfModal = () => {
    setModalPdf(false);
    setPdfLink(null);
  };

  const getIframeSrc = (link: string) => {
    if (!link) return "";
    const cleanPath = link.split("?")[0].toLowerCase();
    
    if (cleanPath.endsWith(".doc") || cleanPath.endsWith(".docx")) {
      return `https://docs.google.com/gview?url=${encodeURIComponent(link)}&embedded=true`;
    }
    return link;
  };

  return (
    <div className="container text-center">
      <div className="d-flex pb-5">
        <div className="col">
          <label className="fw-bold mb-1">Está em Atraso:</label>
          <BadgeStatus description={user?.overdue ? "overdue" : "unoverdue"} />
        </div>
        <div className="col">
          <label className="fw-bold mb-1">Está em Conformidade:</label>
          <BadgeStatus description={user?.compliance ? "complianceUsers" : "uncompliance"} />
        </div>
      </div>

      {loading ? (
        <span className="spinner-border text-primary mt-5"></span>
      ) : (
        <div className="table-responsive">
          <table className="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4">
            <thead>
              <tr className="fw-bold text-muted bg-light">
                <th className="ps-4 fs-7 min-w-200px text-start">Descrição</th>
                <th className="fs-7 min-w-150px text-start">Início Validade</th>
                <th className="fs-7 min-w-150px text-start">Duração</th>
                <th className="fs-7 min-w-150px text-start">Plano</th>
                <th className="fs-7 min-w-150px text-start">Valor</th>
                <th className="fs-7 text-center">Status</th>
                <th className="pe-4 text-end min-w-150px">Ações</th>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(contracts) && contracts.length === 0 ? (
                <tr>
                  <td colSpan={7} className="text-center py-4 text-muted">Nenhum contrato encontrado.</td>
                </tr>
              ) : (
                Array.isArray(contracts) && contracts.map((contract, index) => (
                  <tr key={index}>
                    <td className="ps-4 text-start">
                      <span className="text-dark fw-bold text-hover-primary d-block fs-6">
                        {contract.description || "Sem Descrição"}
                      </span>
                    </td>
                    <td className="text-start">
                      <span className="text-muted fw-semibold d-block fs-7">
                        {contract.start_date ? new Date(contract.start_date).toLocaleDateString('pt-BR') : "--"}
                      </span>
                    </td>
                    <td className="text-start">
                      <span className="text-muted fw-semibold d-block fs-7">
                        {contract.plan_duration ? `${contract.plan_duration} meses` : "--"}
                      </span>
                    </td>
                    <td className="text-start">
                      <span className="text-muted fw-semibold d-block fs-7">
                        {contract.plan_name || "--"}
                      </span>
                    </td>
                    <td className="text-start">
                      <span className="text-muted fw-semibold d-block fs-7">
                        {contract.plan_amount 
                          ? Number(contract.plan_amount).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }) 
                          : "--"}
                      </span>
                    </td>
                    <td className="text-center">
                      <BadgeStatus description={contract.status?.description || contract.status} />
                    </td>
                    <td className="pe-4 text-end">
                      {/* 🟢 NOVO: Botão para Visualizar Faturas */}
                      <button
                        type="button" 
                        onClick={() => {
                          setSelectedContractForInvoices(contract);
                          setShowInvoicesModal(true);
                        }}
                        className="btn btn-icon btn-bg-light btn-active-color-success btn-sm me-2"
                        title="Visualizar Faturas"
                      >
                        <i className="fa-solid fa-file-invoice-dollar fs-5 text-success"></i>
                      </button>

                      {/* Botão de Visualizar PDF do Contrato */}
                      <button
                        type="button" 
                        onClick={() => handleViewContract(contract)}
                        className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
                        title="Visualizar Contrato"
                      >
                        <img src="/media/svg/shapes/eye.svg" alt="Visualizar" />
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* RENDERIZAÇÃO DA MODAL DE FATURAS */}
      <UserInvoicesModal
        show={showInvoicesModal}
        onHide={() => setShowInvoicesModal(false)}
        contract={selectedContractForInvoices}
        _user_id={_user_id} /* 🟢 PASSANDO O ID DO USUÁRIO PARA A MODAL */
      />

      <Modal show={modalPdf} onHide={closePdfModal} size="xl" centered style={{ zIndex: 1060 }}>
        <Modal.Header closeButton>
          <Modal.Title>Visualizar Contrato</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ height: "80vh", padding: 0 }}>
          {pdfLink ? (
            <iframe
              src={getIframeSrc(pdfLink)}
              width="100%"
              height="100%"
              title="Visualizador de Contrato"
              style={{ border: "none" }}
            />
          ) : (
            <div className="d-flex justify-content-center align-items-center h-100">
              <p>Nenhum documento disponível.</p>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default UserFinancialTab;